// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import { message } from './utils/preventDuplicateMessage'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import App from './App'
import router from './router'
// import remoteApi from './api';
import { MessageBox } from "element-ui";
// Vue.use(remoteApi);
import {conn} from "./utils/WebIM.js";
import './utils/filter.js';

import i18n from './i18n/index';

import "font-awesome/css/font-awesome.css"
import store from './vuex/index.js'
import qs from 'qs';
import axios from "axios";
// jquery
import jquery from 'jquery'
// 刻度尺
import CsRuler from 'cs-ruler'
//拖拽
import VDragged from 'v-dragged'
//复制
import Clipboard from 'clipboard'
import "themePath/auto";
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$Clipboard = Clipboard;
import x2js from 'x2js' //xml数据处理插件
Vue.prototype.$x2js = new x2js() //全局方法挂载
Vue.prototype.$message = message; //使用自定义的messagebox
Vue.prototype.$MessageBox = MessageBox; //使用自定义的messagebox
Vue.prototype.conn = conn; //使用自定义的messagebox
// 格式化数字
Vue.filter('formatNumberTwo', (number, tag = 'k') => {
    number = Number(number);
    if (number >= 1000) {
        return (Math.floor(number / 100) / 10).toFixed(1) + tag;
    } else {
        return number;
    }
});
Vue.use(VDragged)
Vue.use(CsRuler)
    // Vue.use(jquery)

router.beforeEach((to, form, next) => {
        console.log("form", form, to)
        if (to.name == 'login') {
            next()
        } else {
            next()
                // if (window.localStorage.getItem('UserMessage')) {
                //     //防止用户在浏览器手动输入访问没有权限的模块
                //     let user = JSON.parse(window.localStorage.getItem('UserMessage'));
                //     let toPath = to.path;//获取目标路径
                //     if(user.reserveUser){
                //         next();
                //     }else if(toPath.indexOf('monitor') > -1 && user.rightdata.indexOf('right.menu.monitor') > -1 ){
                //         next();
                //     }else if(toPath.indexOf('content') > -1 && user.rightdata.indexOf('right.menu.content') > -1 ){
                //         next();
                //     }else if(toPath.indexOf('secretKey') > -1 && user.rightdata.indexOf('right.menu.kdm') > -1 ){
                //         next();
                //     }else if(toPath.indexOf('schedule') > -1 && user.rightdata.indexOf('right.menu.schedule') > -1 ){
                //         next();
                //     }else if(toPath.indexOf('system') > -1 && user.rightdata.indexOf('right.menu.system') > -1 ){
                //         next();
                //     }else if(toPath.indexOf('smartelectricbox') > -1 && user.rightdata.indexOf('right.menu.intelligence') > -1 ){
                //         next();
                //     }else{
                //         next({path:form.path});
                //     }
                // } else {
                //     next({ path: '/login' });
                // }
        }

    })
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js